module.exports = __webpack_public_path__ + "img/icon_category_01_w.b297db75.svg";